import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { BodySmall, BodySmallBold } from 'styles/typography';
import NoUnreadNotificationsIcon from 'svg/NoUnreadNotificationsIcon';

// Distinct empty states per tab (§5 item 6, copy from Figma node 8413-4244), plus a search-empty
// variant: the tab copy ("No unread notifications / Switch to All…") would mislead when the tab
// actually has items and it's the search that matched nothing. Search copy isn't in the mock — a
// deliberate addition to avoid shipping misleading copy (reviewer/product to confirm wording).
const COPY = {
  unread: {
    title: 'No unread notifications',
    subtitle: 'Switch to "All" to view past notifications',
  },
  all: {
    title: 'No notifications yet',
    subtitle: 'Notifications received in Olio will be shown here',
  },
  search: {
    title: 'No matching notifications',
    subtitle: 'Try a different patient name or search term',
  },
} as const;

type Props = { tab: 'unread' | 'all'; searching?: boolean };

export default function NotificationEmptyState({ tab, searching = false }: Props) {
  const { title, subtitle } = COPY[searching ? 'search' : tab];

  return (
    <Container data-testid='notificationsEmptyState'>
      <NoUnreadNotificationsIcon width={48} height={48} />
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Container>
  );
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 48px 24px;
  text-align: center;
`;

const Title = styled(BodySmallBold)`
  color: ${colors.black100};
  margin: 0;
`;

const Subtitle = styled(BodySmall)`
  color: ${colors.black50};
  margin: 0;
`;
